<template>
  <div class="mb-50 container">
    <!--${product.id == 1 ? 'img-product-subscription-one' : ''} -->
    <div class="row mt-lg-15">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 d-flex align-items-center justify-content-center">
        <img :class="`mt-lg-10`" :src="product.url_image" alt=""> <br>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
        <div class="info-subscription color-blue">
          <h1 class="font-backward mb-5">{{ product.name }}</h1>
          <p class="w-100 font-general-r font-weight-bold" v-html="product.description"></p>
          <p class="font-general-r font-weight-bold h4">
            {{ currencyFormat(product.price) }}
          </p>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                color="accent"
                v-bind="attrs"
                v-on="on"
                style="padding: 0 0 !important"
              >
                {{ subscription.subscription_type ? subscription.subscription_type.name : 'TIPO DE SUSCRIPCIÓN'}}
                <v-icon color="primary">mdi-menu-swap</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in product.types_allowed"
                :key="index"
                @click="changeSubscriptionType(item)"
              >
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-textarea
            clearable
            clear-icon="mdi-close-circle"
            color="primary"
            auto-grow
            outlined
            rows="3"
            row-height="20"
            v-model="subscription.comments"
            class="mt-3"
            label="Indícanos que no te gusta, o a que eres alérgico *"
            style="max-width: 500px"
          ></v-textarea>
          <v-btn
            :loading="loading_btn_subscription"
            @click="paymentSubscription(product)"
            elevation="0"
            color="primary"
            class="nv-btn nv-btn-large nv-btn-hover d-none d-sm-none d-md-block"
          >COMPRAR</v-btn>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row justify-content-center">
        <div
          class="col-lg-10 col-md-11 col-sm-12"
        >
          <div class="d-flex align-items-center flex-wrap">
            <p class="center-content-sm h5 color-blue font-general-r mr-2 mt-2">SABORES:</p>
            <v-chip
              class="mr-2 mb-2"
              color="primary"
              v-for="(flavor, i) in subscription.flavors"
              :key="i"
              :close="flavor.remove"
              @click:close="removeFlavor(i)"
            >
              {{flavor.name}}
            </v-chip>
          </div>

          <div class="row mt-5" v-for="(item, index) in flavors" :key="index">
            <div
              v-for="(flavor, index) in item.flavors"
              :key="index"
              class="col-lg-3 col-md-4 col-xs-6 col-sm-6 col-6"
              style="padding-bottom: 0; padding-top: 0"
            >
              <p @click="selectFlavor(flavor, item.key_)" :class="`h5 ${ flavorSelected(flavor.id) ? 'color-primary' : 'color-blue' } font-general-r text-uppercase pointer`">
                {{ flavor.name }}
              </p>
            </div>
            <div class="col-lg-3 col-md-4 col-xs-6 col-sm-6 col-6">
              <p
                @click="selectFlavor(option_temporada, 'temporada')"
                :class="`h5 ${ flavorSelected('temporada') ? 'color-primary' : 'color-blue' } font-general-r text-uppercase pointer`"
              >
                SABOR DE TEMPORADA
              </p>
            </div>
          </div>

        </div>

        <p class="h5 color-blue font-general-r text-center mt-5">
          LOS ENVÍOS SE REALIZARÁN EL PRIMER DÍA HÁBIL DEL MES O DE LA QUINCENA. <br> LOS PEDIDOS ADICIONALES, NO HACEN PARTE DE LA MEMBRESÍA
        </p>

      </div>

      <div class="d-block d-sm-block d-md-none text-center">
        <v-btn
          :loading="loading_btn_subscription"
          @click="paymentSubscription(product)"
          elevation="0"
          color="primary"
          class="nv-btn nv-btn-large nv-btn-hover"
        >COMPRAR</v-btn>
      </div>

    </div>

  </div>
</template>

<script>
import { currencyFormat } from '@/helpers'

export default {
  props: ['product', 'flavors'],
  data: () => ({
    option_temporada: {id: 'temporada', name: 'SABOR DE TEMPORADA', remove: true},
    overlay: false,
    select_type_subscription: '',
    open_message: '',
    message: '',
    loading_btn_subscription: false,

    subscription: {
      flavors: [],
      flavors_ids: [],
      subscription_type: '',
      product: '',
      price: 0.00,
      comments: ''
    }
  }),
  methods: {
    paymentSubscription(product) {
      if (this.subscription.flavors_ids.length < product.quantity_products) return this.$swal(`Para ${product.name} debes seleccionar ${product.quantity_products} ${product.quantity_products > 1 ? 'sabores' : 'sabor' }`, '', 'warning')
      if (!this.subscription.subscription_type) return this.$swal('Debes seleccionar el tipo de la suscripción', '', 'warning')
      this.subscription.comments = this.subscription.comments.trim()
      if (this.subscription.comments == '') {
        return this.$swal('Indícanos que no te gusta o a que eres alérgico', '', 'warning')
      }
      delete product.types_allowed
      this.subscription.product = product
      this.loading_btn_subscription = true
      this.$store.dispatch('setNewSubscription', this.subscription)
      setTimeout(() => {
        this.$router.push({path: '/procesar-suscripcion', query: {step:'direccion-envio'}})
      }, 1000)
    },
    changeSubscriptionType(item) {
      this.subscription.price = this.product.price
      this.subscription.subscription_type = item
    },
    removeFlavor(index) {
      this.subscription.flavors.splice(index, 1)
      this.subscription.flavors_ids.splice(index, 1)
    },
    selectFlavor(flavor, key_category_flavor) {
      if (flavor.id == 'temporada') {
        let count_flavor_temporada = this.subscription.flavors.filter(i => i.id == 'temporada')
        if (count_flavor_temporada.length == 4) {
          this.$swal(
            `Solo puedes elegir 4 sabores de temporada`,
            '',
            'warning'
          )
          return false
        }
      }
      //if (!this.subscription.flavors_ids.includes(flavor.id)) {
      if (this.subscription.flavors.length < this.product.quantity_products) {
        this.subscription.flavors.push({
          id: flavor.id,
          name: flavor.name,
          category_key: key_category_flavor,
          remove: true
        })
        this.subscription.flavors_ids.push(flavor.id)
      } else {
        this.$swal(
          `Para esta suscripción solo puedes elegir ${this.product.quantity_products} ${this.product.quantity_products > 1 ? 'sabores' : 'sabor'}`,
          '',
          'warning'
        )
      }
    },
    flavorSelected(flavor_id) {
      if (this.subscription.flavors_ids.includes(flavor_id)) {
        return true
      } else {
        return false
      }
    },
    currencyFormat(price) {
			return currencyFormat(price)
    }
  }
}
</script>

<style scoped>
  .container-products {
    width: 90%;
    margin: auto;
  }
  .v-chip.v-size--default {
    border-radius: 0px;
    text-transform: uppercase;
    font-weight: 500;
  }
</style>
